import { SET_DEFINITION, SET_DEFINITIONS } from "./actions";
import SelectionState from "state/selections/SelectionState";
import { SummaryType } from "@ls/grouping-service";
import { COMMIT_SELECTIONS } from "state/selections/actionTypes";
import {
  RECEIVE_ANALYTIC_VALUES,
  RECEIVE_ANALYTICS_DATA,
  RECEIVE_ANALYTICS_SBS_DATA,
  RECEIVE_ANALYTICS_RATIO_DATA,
  REQUEST_ANALYTIC_VALUES,
  REQUEST_ANALYTICS_DATA,
  REQUEST_ANALYTICS_SBS_DATA,
  REQUEST_ANALYTICS_RATIO_DATA,
} from "./actions";
import produce from "immer";
import { DELETE_COLUMN } from "state/grid/actions";
import {
  removeDefinitionFromState,
  setDefinitionToState,
} from "state/grid/utils";

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
  fetchingAnalyticValues: false,
  analyticValues: [],
  fetchingAnalyticsData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  analyticsData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
  fetchingAnalyticsRatioData: false,
  analyticsRatioData: null,
  fetchingAnalyticsSbsData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  analyticsSbsData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      return setDefinitionToState(state, action.idx, action.definition);
    }
    case DELETE_COLUMN: {
      return removeDefinitionFromState(state, action.payload);
    }
    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }
    case COMMIT_SELECTIONS: {
      /**reset data before committing to new params**/
      state.analyticsData = defaultState.analyticsData;
      state.analyticsSbsData = defaultState.analyticsSbsData;

      state.definitions[SelectionState.COMMITTED] =
        state.definitions[SelectionState.UNCOMMITTED];
      break;
    }
    case REQUEST_ANALYTIC_VALUES: {
      state.fetchingAnalyticValues = true;
      state.analyticValues = defaultState.analyticValues;
      break;
    }
    case RECEIVE_ANALYTIC_VALUES: {
      state.fetchingAnalyticValues = false;
      state.analyticValues = action.data;
      break;
    }
    case REQUEST_ANALYTICS_DATA: {
      state.fetchingAnalyticsData[action.summary] = true;
      state.analyticsData[action.summary] =
        defaultState.analyticsData[action.summary];
      break;
    }
    case RECEIVE_ANALYTICS_DATA: {
      state.fetchingAnalyticsData[action.summary] = false;
      state.analyticsData[action.summary] = action.data;
      break;
    }
    case REQUEST_ANALYTICS_RATIO_DATA: {
      state.fetchingAnalyticsRatioData = true;
      state.analyticsRatioData = defaultState.analyticsRatioData;
      break;
    }
    case RECEIVE_ANALYTICS_RATIO_DATA: {
      state.fetchingAnalyticsRatioData = false;
      state.analyticsRatioData = action.data;
      break;
    }
    case REQUEST_ANALYTICS_SBS_DATA: {
      state.fetchingAnalyticsSbsData[action.summary] = true;
      state.analyticsSbsData[action.summary] =
        defaultState.analyticsSbsData[action.summary];
      break;
    }
    case RECEIVE_ANALYTICS_SBS_DATA: {
      state.fetchingAnalyticsSbsData[action.summary] = false;
      state.analyticsSbsData[action.summary] = action.data;
      break;
    }
    default:
      return state;
  }
});
export default reducer;
